var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.containerClass},[(_vm.icon)?_c('span',{class:_vm.iconClass}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_c('span',{staticClass:"p-tag-value"},[_vm._v(_vm._s(_vm.value))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1dced8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/tag/Tag.vue
// module id = u+5K
// module chunks = 38